import React from "react";
import { ActionButton } from "../ActionButton";
import { Icons } from "../Icons";

interface FormActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
  submitText?: string;
  cancelText?: string;
  submitIcon?: React.ReactNode;
  isEditing?: boolean;
  submitVariant?: "primary" | "secondary" | "danger";
  submitType?: "button" | "submit";
}

export const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  onSubmit,
  loading = false,
  submitText,
  cancelText = "Cancelar",
  submitIcon,
  isEditing = false,
  submitVariant = "primary",
  submitType = "button",
}) => {
  const defaultSubmitText = isEditing ? "Atualizar" : "Criar";
  const defaultSubmitIcon = isEditing ? <Icons.Edit sx={{ fontSize: 18 }} /> : <Icons.Add sx={{ fontSize: 18 }} />;

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-end pt-4 border-t border-gray-200 dark:border-slate-700">
      <ActionButton
        variant="outline"
        size="sm"
        onClick={onCancel}
        disabled={loading}
        className="bg-white dark:bg-slate-800 border-2 border-gray-300 dark:border-slate-600 hover:border-gray-400 dark:hover:border-slate-500 text-gray-700 dark:text-slate-200 hover:text-gray-900 dark:hover:text-white"
      >
        {cancelText}
      </ActionButton>

      <ActionButton
        variant={submitVariant}
        size="sm"
        onClick={submitType === "button" ? onSubmit : undefined}
        type={submitType}
        disabled={loading}
        loading={loading}
        icon={submitIcon ?? defaultSubmitIcon}
      >
        {submitText || defaultSubmitText}
      </ActionButton>
    </div>
  );
};
